export default __webpack_public_path__ + "static/media/background.f0db792a.jpg";